<template xmlns="http://www.w3.org/1999/html">
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">学员名单</div>
        <label style="float: right;">注册人数：{{student.registerNum}}人</label>
      </div>
      <div class="body_content class_body_content">
        <button type="button" class="btn btn-default btn_option button1" @click="exporStudent()">导出学员</button>
        <button type="button" class="btn btn-default btn_option button1 stu_export" @click="countLessonTimesExport()">导出学时</button>
        <button type="button" class="btn btn-default btn_option button1 stu_export" @click="exportEvTable()">导出综合评定表</button>
        <div style="margin: 10px 0 0 0">
          <div class="class_body_content_self table-responsive">
            <table class="table table-striped table-bordered tbl_stuList">
              <thead>
              <tr>
                <th class="tablexuhao" style="width: 5%;">序号</th>
                <th style="width:10%;">姓名</th>
                <th style="width:10%">账号</th>
                <th style="width: 5%">性别</th>
                <th style="width:10%">民族</th>
                <th style="width: 10%">出生日期</th>
                <th style="width: 10%">政治面貌</th>
                <th style="width: 20%">工作单位及职务</th>
                <!--<th>职务</th>-->
                <th>联系电话</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(studentLi, index) in list" :key="index">
                <td style="width:5%">{{index+1}}</td>
                <td style="width:10%">{{studentLi.name}}</td>
                <td style="width:10%">{{studentLi.username}}</td>
                <td style="width: 5%">{{studentLi.sex | formatSex}}</td>
                <td style="width: 10%">{{studentLi.nation}}</td>
                <td style="width: 10%">{{studentLi.birthday}}</td>
                <td style="width: 10%">{{studentLi.policitalStatus}}</td>
                <td style="width: 20%;">{{studentLi.department}}</td>
                <!--<td>{{studentLi.duty}}</td>-->
                <td>{{studentLi.tel}}</td>
                <td>
                  <button type="button" class="btn btn-default btn_option okBtn" @click="countLessonTimes(studentLi.id)">学时</button>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal_LessonTimes" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              &times;
            </button>
            <h4 class="modal-title">
              【{{lessonTimes[0]?lessonTimes[0].studentName:""}}】学时统计
            </h4>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-bordered tbl_stuList">
              <thead>
              <tr>
                <th class="tablexuhao" width="10%">序号</th>
                <th width="70%">班级</th>
                <th width="20%">学时</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(l, index) in lessonTimes" :key="index">
                <td  width="10%">{{index+1}}</td>
                <td width="70%">{{l.clazzName}}</td>
                <td width="20%">{{l.result * 4}}</td>
              </tr>
              <tr >
                <td  width="10%">#</td>
                <td width="70%">总计</td>
                <td width="20%">{{totalSumAllLessonTimes}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <!--<button type="button" class="btn btn-default btn_save">保存</button>-->
            <button type="button" class="btn btn-default btn_cancel" data-dismiss="modal">关闭</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {schoolAxios} from '../../main';
  import {getContentSize} from '../mainView';

  import dictionaryData from '../../json/dictionary';

  export default {
    name: "studentListTea",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        token: this.$store.state.access_token,
        //是否可编辑flag
        classInfoEditFlag:this.$store.state.classInfoEditFlag,

        sex_arr: dictionaryData.sex,
        nation_arr: dictionaryData.nation,
        policital_status_arr: dictionaryData.policital_status,

        //学员集合
        list: [],

        option_flag: '',

        //学员对象
        student: {
          id: '',
          name: '',
          username: '',
          sex: '',
          nation: '',
          birthday: '',
          policitalStatus: '',
          department: '',
          duty: '',
          tel: '',
          papersNum:'',
          userId:'',
          registerNum:''
        },

       /* upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'student/excelSaveBatch',
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              clazzId: this.$store.state.clazzId,
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 10*1024*1024*1024,
            singleFile: true,
          },
          attrs: {
            file: {
              extensions: 'xls,xlsx', //允许的文件后缀，不带点，多个用逗号分割，这里支持老版的Excel和新版的
              accept: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },*/

        href: this.$store.state.domain+'stu_temp.xls',

        hrefExport:this.$store.state.serviceBase+"resources/",
        lessonTimes:[],
      }
    },
    filters: {
      formatSex(value){
        let this_ = this;
        if(dictionaryData.sex && value){
          value = dictionaryData.sex[value];
        }
        return value;
      }
    },
    computed:{
      totalSumAllLessonTimes(){
        let totalSumAll = 0;
        this.lessonTimes.map((item) => {totalSumAll += Number(item.result)})
        return totalSumAll*4
      },
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //刷新页面首次加载
        this_.initStudentListData();

        //日期
        this_.dateDefault();

        //绑定加载关闭模态框时的事件
        this_.closeModal();

        //获得上传组件对象
        // this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        // this_.loadUpload();
      });
    },
    methods: {
      initStudentListData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'student/findListByClazzId',
          params: {
            clazzId: this_.clazzId
          }
        }).then(function (resp) {
          if(resp.data.success){
            this_.list = resp.data.list;
            this_.student.registerNum=this_.list.length;
          }
        });
      },
      downloadTemp(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          baseURL: this_.$store.state.domain,
          url: 'stu_temp.xls',
        }).then(function (resp) {

        });
      },
      addStudent(){
        let this_ = this;
        //if(this_.validateDataIsEmpty){
        this_.$validator.validateAll('student').then(result => {
          if (result) {
            let method = "";
            let url = "";
            if (this_.option_flag == "add") {
              method = "post";
              url = "student/add";
            } else {
              method = "put";
              url = "student/editByWeb";
            }
            schoolAxios({
              method: method,
              url: url,
              data: {
                clazzId: this_.clazzId,
                id: this_.student.id,
                name: this_.student.name,
                username: this_.student.username,
                sex: this_.student.sex,
                nation: this_.student.nation,
                birthday: this_.student.birthday,
                policitalStatus: this_.student.policitalStatus,
                department: this_.student.department,
                duty: this_.student.duty,
                tel: this_.student.tel,
                papersNum:this_.student.papersNum,
                userId:this_.student.userId
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                $("#myModal").modal("hide");
                this_.initStudentListData();
                "保存成功".showMessage();
              } else {
                data.message.showMessage();
              }
            })
          }
        });
      },
      editStudent(index){
        let this_ = this;
        let my_data = this_.list[index];
        this_.student = {
          id: my_data.id,
          name: my_data.name,
          username: my_data.username,
          sex: my_data.sex,
          nation: my_data.nation,
          birthday: my_data.birthday,
          policitalStatus: my_data.policitalStatus,
          department: my_data.department,
          duty: my_data.duty,
          tel: my_data.tel,
          papersNum:my_data.papersNum,
          userId:my_data.userId
        };
        $("#myModal").modal("show");
      },
      deleteStudent(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'student/delete/'+id,
            params: {
              clazzId:this_.clazzId
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              this_.initStudentListData();
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },

      /**
       * 验证数据是否为空
       */
      validateDataIsEmpty(){
        let this_ = this;
        if(this_.student.name == ""){
          "请输入名称".showMessage();
          return false;
        }
        if(this_.student.username == ""){
          "请输入用户名".showMessage();
          return false;
        }
        if(this_.student.sex == ""){
          "请选择性别".showMessage();
          return false;
        }
        if(this_.student.nation == ""){
          "请选择民族".showMessage();
          return false;
        }
        if(this_.student.birthday == ""){
          "请选择出生日期".showMessage();
          return false;
        }
        if(this_.student.policitalStatus == ""){
          "请选择政治面貌".showMessage();
          return false;
        }
        if(this_.student.department == ""){
          "请输入工作单位".showMessage();
          return false;
        }
        if(this_.student.duty == ""){
          "请输入职务".showMessage();
          return false;
        }
        if(this_.student.tel == ""){
          "请输入联系电话".showMessage();
          return false;
        }
        return true;
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal_addStudents").on('hide.bs.modal', function () {
          // this_.upload.uploader.cancel();
        });

        $("#myModal").on('hide.bs.modal', function () {
          this_.student = {
            id: '',
            name: '',
            username: '',
            sex: '',
            nation: '',
            birthday: '',
            policitalStatus: '',
            department: '',
            duty: '',
            tel: '',
          }
          setTimeout(function () {
            this_.errors.clear('student');
          });
        });
        $("#modal_LessonTimes").on('hide.bs.modal', function () {
          this_.lessonTimes = [];
        });
      },

      /**
       * 导出学员
       */
      exporStudent(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'student/studentDownload',
          params: {
            "clazzId":this_.clazzId,
            "access_token":this_.token
          }
        }).then(function (response) {
          location.href=this_.hrefExport+response.data.data;
        });
        /* location.href=this_.hrefExport+'?clazzId='+this_.clazzId+'&access_token='+this_.token;*/
      },
      /**
       * 上传加载
       */
     /* loadUpload(){
        let this_ = this;

        this_.upload.uploader.on('fileAdded', function (file, event) {
          if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        });
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          console.info(message);
          if(message){
            let message_ = JSON.parse(message);
            if(message_.success){
              $("#myModal_addStudents").modal("hide");
              this_.initStudentListData();
              "批量保存学员成功".showMessage();
            }else {
              this_.upload.uploader.cancel();
              message_.message.showMessage();
            }
          }
        });
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        });
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        });
      },*/
      /**
       * 导出学员
       */
      exporStudent(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'student/studentDownload',
          params: {
            "clazzId":this_.clazzId,
            "access_token":this_.token
          }
        }).then(function (response) {
          location.href=this_.hrefExport+response.data.data;
        });
        /* location.href=this_.hrefExport+'?clazzId='+this_.clazzId+'&access_token='+this_.token;*/
      },
      /**
       * 初始化日期选这框
       */
      dateDefault() {
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#startDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#startDate").val();
          this_.student.birthday = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
      },
      countLessonTimes(studentId){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'attendance/validCountByClass',
          params: {
            "studentId":studentId
          }
        }).then(function (response) {
          let data = response.data
          if(data.success){
            if(data.list.length == 0){
              "无考勤记录，无法统计数据".showMessage();
              return;
            }
            this_.lessonTimes = data.list;
            $("#modal_LessonTimes").modal("show");
          }else{
            (data.message||"数据加载失败").showMessage();
          }
        });
      },
      countLessonTimesExport(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'attendance/validCountByClassExport',
          params: {
            "clazzId":this_.clazzId
          }
        }).then(function (response) {
          let data = response.data
          if(data.success){
            location.href=this_.hrefExport+data.data;
          }else{
            (data.message||"数据导出失败").showMessage();
          }
        });
      },
      exportEvTable(){
        let this_=this;
        schoolAxios({
          timeout:60000,
          method: 'get',
          url:'student/exportEvTable',
          params: {
            "clazzId":this_.clazzId
          }
        }).then(function (response) {
          let data = response.data
          if(data.success){
            location.href=this_.hrefExport+data.data;
          }else{
            (data.message||"数据导出失败").showMessage();
          }
        });
      }

    }
  }
</script>

<style scoped>
  @import '../../assets/css/plugins.css';
  @import "../../assets/css/publicStyle.css";
  .table {
    color: #FFFFFF;
  }
  .table th {
    color: black;
    background-color: #cccccc;
  }
  .table tr{
    color: black;
    background-color: #FFFFFF;
  }
  .table th {
    text-align: center;
  }
  .table td {
    text-align: center;
    line-height: 28px;
  }
  .button1 {
    padding: 5px 25px;
  }
  .class_body_content {
    top: 10%;
    height: 90%;
  }
  .trainingSchedule_form input,.trainingSchedule_form select {
    width: 330px;
    height: 32px;
    margin:10px;
  }
  .modelInput{
    height: 34px;
    width: 90%;
    margin-top: 2%;
    margin-left: 5%;
  }
  .modeldanxuan{
    margin-left: 20%;
  }

  .okBtn {
    width: 50px;
    line-height: 12px;
  }

  input.form-control.modelInput {
    display: inline-block;
    width: 92%;
  }

  select.form-control.modelInput {
    display: inline-block;
    width: 92%;
  }

  .uploader-drop {
    text-align: center;
  }
  /*表头固定*/
  .tbl_stuList thead tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_stuList tbody{
    height: 450px;
    /*overflow-y: scroll;*/
    overflow: auto;
  }
  .tbl_stuList tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .tbl_stuList{
    border: none;
  }
  .tbl_stuList tbody::-webkit-scrollbar{
    width:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherClass/studentListTea.vue